/**
 * Created by Carsten Hibbeler
 * Date: 11.04.2018
 */

import React, { useEffect } from 'external/react';
import PropTypes from 'external/prop-types';

import { FormControl } from 'external/react-bootstrap';
import DatePicker from 'external/react-datepicker';
import 'external/react-datepicker-css';
import '../css/date-picker.scss';
import datefns from 'external/datefns';

const handleChange = ({ startDate, endDate, onChange }) => {
    if (datefns.isAfter(startDate, endDate)) {
        endDate = startDate;
    }
    onChange && onChange({ startDate, endDate });
};

const DateRangeFormComponent = ({
    minDate,
    maxDate,
    startDate,
    endDate,
    onChange,
    inline,
    disabled,
    dateFormat = 'dd.MM.yyyy HH:mm',
    timeFormat = 'HH:mm',
    timeCaption = 'Uhrzeit',
    startLabel = 'Von',
    endLabel = 'Bis',
    ...rest
}) => {
    
    

    startDate = startDate ? new Date(startDate) : new Date();
    endDate = endDate ? new Date(endDate) : new Date();
    minDate = minDate ? new Date(minDate) : null;
    maxDate = maxDate ? new Date(maxDate) : null;

    useEffect(() => {
        if(!disabled) {
            handleChange({ startDate, endDate, onChange })
        }
    }, [disabled]);

    const props = {
        ...rest,
        //inline: props.inlineCal, /* inline is used by React Bootstrap and DatePicker */
        disabled,
        dateFormat,
        timeFormat,
        timeCaption,
        startLabel,
        endLabel,
        minDate,
        maxDate,
        startDate,
        endDate
    };

    return (
        <div className="d-block date-range-picker">
            <div className="d-inline-block mr-auto mb-2">
                <label className="date-picker-start-label" htmlFor="date-picker-start">
                    {startLabel}
                </label>
                <DatePicker
                    {...props}
                    id="date-picker-start"
                    selected={startDate}
                    selectsStart
                    allowSameDay
                    onChange={v => handleChange({ startDate: v, endDate, onChange })}
                />
            </div>

            <div className="d-inline-block mb-2">
                <label className="date-picker-end-label" htmlFor="date-picker-end">
                    {endLabel}
                </label>
                <DatePicker
                    {...props}
                    id="date-picker-end"
                    selected={endDate}
                    selectsEnd
                    allowSameDay
                    onChange={v => handleChange({ startDate, endDate: v, onChange })}
                />
            </div>
        </div>
    );
};

const DateRangePicker = props => <FormControl {...props} as={DateRangeFormComponent}/>;

//https://reactdatepicker.com/ & https://github.com/Hacker0x01/react-datepicker/blob/master/src/index.jsx
DateRangePicker.propTypes = {
    onChange: PropTypes.func,
    inline: PropTypes.bool,
    startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    minDate: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    maxDate: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    startLabel: PropTypes.node,
    endLabel: PropTypes.node,
    timeFormat: PropTypes.string,
    timeCaption: PropTypes.string,
    disabled: PropTypes.bool,
};

DateRangeFormComponent.propTypes = DateRangePicker.propTypes;

export default DateRangePicker;



// WEBPACK FOOTER //
// ./js/components/DateRangePicker.jsx